import React, { useEffect, useState } from 'react'
import { withRouter } from 'react-router-dom'
import { connect } from 'react-redux'
import {
  hideLoadingBox,
  showLoadingBox,
  showMessageBox,
} from '../../../../store/actions/system.actions'
import { errorHandler } from '../../../../services/util/error.service'
import {
  calcularQtePalletPorArea,
  calcularQtePalletPorMetrica,
  getQtePalletPorArea,
  postQtePalletPorArea,
} from '../../../../services/api/https/picking/picking-qte-pallet-area.http'
import { validarEtiquetaIdentificadorVolumes } from '../../../../services/api/https/picking/etiqueta-identificador-volumes.http'
import {
  CustomPanel,
  InputText,
  Loading,
  OutlinedBtnPrimary,
  PageHeader,
  CustomRadioButton,
  InputNumeroDecimal,
  Btn,
} from '../../../../components'
import { DataTable } from 'primereact/datatable'
import { Column } from 'primereact/column'
import { Checkbox } from 'primereact/checkbox'
import { tableCellCentered } from '../../../../assets/js/styles'
import {
  urlReportEtiquetaIdentificadorVolumes,
  urlReportTagLoteDeCarregamento,
  urlReportTagPallet,
  urlReportTagParaPickingPorGrupo,
  urlReportTagParaPickingPorProduto,
  urlReportTagParaPickingPorRota,
  urlReportTagPickingCliente07,
  urlReportTagPickingClienteCodigoBarras,
  urlReportTagPickingClienteSimplificado10,
  urlReportTagPickingCidades08,
  urlReportTagPickingGrupoProdutoCodigoBarras12,
  urlReportTagSimplificado,
} from '../../../../services/api/routes/picking.routes'
import { SplitButton } from 'primereact/splitbutton'
import '../../../../assets/css/utilities.css'

const CALC_TYPES = [
  { label: 'Por Peso (KG)', value: 'peso' },
  { label: 'Por Sku', value: 'sku' },
]

function TagPallet({ dispatch, history }) {
  // Vars
  const { picking_id } = history.location.state

  // Hooks
  const [isLoading, setIsLoading] = useState(true)
  const [qtePalletPorArea, setQtePalletPorArea] = useState([])
  const [selectedAreaIds, setSelectedAreaIds] = useState([])
  const [valorCalculo, setValorCalculo] = useState('')
  const [tipoCalculo, setTipoCalculo] = useState('peso')

  useEffect(() => {
    getQtePallet()
  }, [])

  const splitButtonsItems = [
    {
      label: '02. Areas de Separação ',
      command: () => onBtnGerarTagAreas(),
    },
    {
      label: '03. Lote de Carregamento',
      command: () => onBtnGerarTagsLoteCarregamento(),
    },
    {
      label: '04. Picking - Produto',
      command: () => onBtnGerarTagsParaPickingPorProduto(),
    },
    {
      label: '05. Picking - Grupo Produto',
      command: () => onBtnGerarTagsParaPickingPorGrupo(),
    },
    {
      label: '06. Picking - Rota',
      command: () => onBtnGerarTagsParaPickingPorRota(),
    },
    {
      label: '07. Picking - Cliente',
      command: () => onBtnGerarTagsPickingCliente07(),
    },
    {
      label: '08. Picking - Cidades',
      command: () => onBtnGerarTagsPickingCidades08(),
    },
    {
      label: '09. Picking Cliente - Código de Barras',
      command: () => onBtnGerarTagsPickingClienteCodigoBarras(),
    },
    {
      label: '10. Picking - Cliente - Simplificado',
      command: () => onBtnGerarTagsPickingClienteSimplificado10(),
    },
    {
      label: '11. Etiqueta Identificadora de Volumes',
      command: () => onBtnGerarEtiquetaIdentificadoraVolumes11(),
    },
    {
      label: '12. Picking - Grupo Produto - Códigos de Barras',
      command: () => onBtnGerarTagsPickingGrupoProdutoCodigoBarras12(),
    },
  ]

  // Checkbox helpers
  const isAreaSelected = row => selectedAreaIds.includes(row.pickingarea_id)

  const onAreaCheckboxChange = row => {
    const id = row.pickingarea_id
    if (selectedAreaIds.includes(id)) {
      setSelectedAreaIds(selectedAreaIds.filter(a => a !== id))
    } else {
      setSelectedAreaIds([...selectedAreaIds, id])
    }
  }

  const isAllSelected = qtePalletPorArea.length > 0 && selectedAreaIds.length === qtePalletPorArea.length

  const onSelectAllChange = () => {
    if (isAllSelected) {
      setSelectedAreaIds([])
    } else {
      setSelectedAreaIds(qtePalletPorArea.map(r => r.pickingarea_id))
    }
  }

  // Validation
  const validateAreaSelection = () => {
    if (selectedAreaIds.length === 0) {
      dispatch(showMessageBox(null, 'Selecione pelo menos uma área'))
      return false
    }
    return true
  }

  // Events
  const onBtnGerarTagAreas = () => {
    if (!validateAreaSelection()) return
    const url = urlReportTagPallet(picking_id, selectedAreaIds)
    window.open(url, '_blank')
  }

  const onBtnGerarTagsLoteCarregamento = () => {
    if (!validateAreaSelection()) return
    const url = urlReportTagLoteDeCarregamento(picking_id, selectedAreaIds)
    window.open(url, '_blank')
  }

  const onBtnGerarTagsParaPickingPorProduto = () => {
    if (!validateAreaSelection()) return
    const url = urlReportTagParaPickingPorProduto(picking_id, selectedAreaIds)
    window.open(url, '_blank')
  }

  const onBtnGerarTagsParaPickingPorGrupo = () => {
    if (!validateAreaSelection()) return
    const url = urlReportTagParaPickingPorGrupo(picking_id, selectedAreaIds)
    window.open(url, '_blank')
  }

  const onBtnGerarTagsParaPickingPorRota = () => {
    if (!validateAreaSelection()) return
    const url = urlReportTagParaPickingPorRota(picking_id, selectedAreaIds)
    window.open(url, '_blank')
  }

  const onBtnGerarTagsSimplificado = () => {
    if (!validateAreaSelection()) return
    const url = urlReportTagSimplificado(picking_id, selectedAreaIds)
    window.open(url, '_blank')
  }
  const onBtnGerarTagsPickingCliente07 = () => {
    if (!validateAreaSelection()) return
    const url = urlReportTagPickingCliente07(picking_id, selectedAreaIds)
    window.open(url, '_blank')
  }

  const onBtnGerarTagsPickingCidades08 = () => {
    if (!validateAreaSelection()) return
    const url = urlReportTagPickingCidades08(picking_id, selectedAreaIds)
    window.open(url, '_blank')
  }

  const onBtnGerarTagsPickingClienteCodigoBarras = () => {
    if (!validateAreaSelection()) return
    const url = urlReportTagPickingClienteCodigoBarras(picking_id, selectedAreaIds)
    window.open(url, '_blank')
  }

  const onBtnGerarTagsPickingClienteSimplificado10 = () => {
    if (!validateAreaSelection()) return
    const url = urlReportTagPickingClienteSimplificado10(picking_id, selectedAreaIds)
    window.open(url, '_blank')
  }

  const onBtnGerarEtiquetaIdentificadoraVolumes11 = async () => {
    if (!validateAreaSelection()) return

    const areaIds = qtePalletPorArea
      .filter(r => selectedAreaIds.includes(r.pickingarea_id))
      .map(r => r.pickingarea_id)

    const janela = window.open('', '_blank')
    try {
      dispatch(showLoadingBox('Gerando a Etiqueta Identificadora de Volumes'))

      const errosPorArea = await validarEtiquetaIdentificadorVolumes(picking_id, areaIds)
      if (errosPorArea.length > 0) {
        throw new Error(
          `Não foi possível emitir a Etiqueta Identificadora de Volumes:\n${errosPorArea.join('\n')}`,
        )
      }

      janela.location.href = urlReportEtiquetaIdentificadorVolumes(picking_id, areaIds)
    } catch (e) {
      if (janela) janela.close()
      dispatch(showMessageBox(null, errorHandler(e)))
    } finally {
      dispatch(hideLoadingBox())
    }
  }

  const onBtnGerarTagsPickingGrupoProdutoCodigoBarras12 = () => {
    if (!validateAreaSelection()) return
    const url = urlReportTagPickingGrupoProdutoCodigoBarras12(picking_id, selectedAreaIds)
    window.open(url, '_blank')
  }

  const onBtnSalvar = async () => {
    try {
      const areasParaSalvar = qtePalletPorArea.filter(r => r.qte_pallet && r.qte_pallet > 0)
      await postQtePalletPorArea(picking_id, areasParaSalvar)
      dispatch(showMessageBox('Operação Realizada com Sucesso', null))
    } catch (e) {
      dispatch(showMessageBox(null, errorHandler(e)))
    }
  }

  const onQtePalletChange = (row, qte_pallet) => {
    const { pickingarea_id } = row
    const index = qtePalletPorArea.findIndex(p => p.pickingarea_id === pickingarea_id)
    if (index !== -1) {
      const nQtePalletArea = [...qtePalletPorArea]
      nQtePalletArea[index].qte_pallet = qte_pallet
      setQtePalletPorArea(nQtePalletArea)
    }
  }

  const onBtnCalcularQtePalletPorAreaClick = async () => {
    if (!validateAreaSelection()) return
    try {
      dispatch(showLoadingBox('Calculando a quantidade de Pallets por Área'))
      const fetchedQtePalletPorArea = await calcularQtePalletPorArea(picking_id)
      // Aplica o cálculo apenas nas áreas selecionadas, mantendo as demais inalteradas
      const merged = qtePalletPorArea.map(existing => {
        if (!selectedAreaIds.includes(existing.pickingarea_id)) return existing
        const calculated = fetchedQtePalletPorArea.find(
          f => f.pickingarea_id === existing.pickingarea_id,
        )
        return calculated ? calculated : existing
      })
      setQtePalletPorArea(merged)
      dispatch(showMessageBox('Cálculo realizado com Sucesso', null))
    } catch (e) {
      dispatch(showMessageBox(null, errorHandler(e)))
    } finally {
      dispatch(hideLoadingBox())
    }
  }

  const onBtnCalcularClick = async () => {
    if (!validateAreaSelection()) return
    try {
      if (!valorCalculo || valorCalculo <= 0) {
        dispatch(showMessageBox(null, 'Insira um valor válido maior que zero'))
        return
      }

      dispatch(showLoadingBox('Calculando a quantidade de Pallets por Área'))
      const fetchedQtePalletPorArea = await calcularQtePalletPorMetrica(
        picking_id,
        Number(valorCalculo),
        tipoCalculo,
      )
      // Aplica o cálculo apenas nas áreas selecionadas, mantendo as demais inalteradas
      const merged = qtePalletPorArea.map(existing => {
        if (!selectedAreaIds.includes(existing.pickingarea_id)) return existing
        const calculated = fetchedQtePalletPorArea.find(
          f => f.pickingarea_id === existing.pickingarea_id,
        )
        return calculated ? calculated : existing
      })
      setQtePalletPorArea(merged)
      dispatch(showMessageBox('Cálculo realizado com Sucesso', null))
    } catch (e) {
      dispatch(showMessageBox(null, errorHandler(e)))
    } finally {
      dispatch(hideLoadingBox())
    }
  }

  // Helpers
  const getQtePallet = async () => {
    try {
      const fetchedQtePalletPorArea = await getQtePalletPorArea(picking_id)
      setQtePalletPorArea(fetchedQtePalletPorArea)
      setSelectedAreaIds(fetchedQtePalletPorArea.map(r => r.pickingarea_id))
    } catch (e) {
      dispatch(showMessageBox(null, errorHandler(e)))
    } finally {
      setIsLoading(false)
    }
  }

  // Renders
  return (
    <>
      <PageHeader>Tag Pallet</PageHeader>
      <div style={{ marginTop: 20 }}>
        <CustomPanel btnLabel="Salvar" onNovo={onBtnSalvar} onVoltar={history.goBack}>
          {isLoading ? (
            <div className="text-center">
              <Loading />
            </div>
          ) : (
            <div className="p-grid">
              <div className="p-col-12">
                <div className="p-grid p-align-end">
                  <div className="p-col-fixed" style={{ width: 'fit-content' }}>
                    <SplitButton
                      menuStyle={{ width: 340 }}
                      className="bck-primary"
                      label="01. Simplificado"
                      icon="pi pi-tags"
                      onClick={() => onBtnGerarTagsSimplificado()}
                      model={splitButtonsItems}
                    ></SplitButton>
                  </div>
                  <div className="p-col-fixed" style={{ width: 'fit-content', marginLeft: 10 }}>
                    <OutlinedBtnPrimary
                      onClick={onBtnCalcularQtePalletPorAreaClick}
                      label={'Calcular Qte Pallet por Área'}
                    />
                  </div>
                  <div className="p-col-3">
                    <div style={{ marginLeft: -10 }}>
                      <CustomRadioButton
                        items={CALC_TYPES}
                        value={tipoCalculo}
                        onChange={value => setTipoCalculo(value)}
                        labelColor="#14B0BF"
                        labelFontSize="0.8rem"
                      />
                    </div>
                    <InputNumeroDecimal
                      label={''}
                      value={valorCalculo}
                      onChange={value => setValorCalculo(value)}
                      marginTop={0}
                    />
                  </div>
                  <div className="p-col-fixed" style={{ width: 'fit-content' }}>
                    <Btn onClick={onBtnCalcularClick}>Calcular</Btn>
                  </div>
                </div>
              </div>
              <div className="p-col-12">
                <DataTable value={qtePalletPorArea}>
                  <Column
                    header={<Checkbox onChange={onSelectAllChange} checked={isAllSelected} />}
                    style={{ width: '3em' }}
                    body={rowData => (
                      <Checkbox
                        checked={isAreaSelected(rowData)}
                        onChange={() => onAreaCheckboxChange(rowData)}
                      />
                    )}
                  />
                  <Column field="pickingarea_name" header="Area" />
                  <Column field="weight_total" header="Peso Total" style={tableCellCentered()} />
                  <Column field="qte_sku" header="Qte Sku" style={tableCellCentered()} />
                  <Column
                    header="Qte. Pallet"
                    style={tableCellCentered()}
                    body={row => (
                      <InputText
                        marginTop={0}
                        value={row.qte_pallet ? row.qte_pallet : ''}
                        onChange={qte_pallet => onQtePalletChange(row, Number(qte_pallet))}
                      />
                    )}
                  />
                </DataTable>
              </div>
            </div>
          )}
        </CustomPanel>
      </div>
    </>
  )
}

export default connect()(withRouter(TagPallet))

